<div class="wrapper-wide mt-section">
  <div class="page-wide">

    <div class="verified" *ngIf="!loader && success">
      <div fxLayout="d-flex justify-content-around align-items-center">
        <h3> <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor"
            class="bi bi-patch-check-fill" viewBox="0 0 16 16">
            <path
              d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708" />
          </svg>Your email has been sucessfully verified!</h3>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-around center"><a routerLink="/login"><button
            class="btn btn-outline-primary">Login Now</button></a></div>
    </div>

    <div class="verify-fail" *ngIf="!loader && !success">
      <div fxLayout="row" fxLayoutAlign="space-around center">
        <h3>The link is invalid or has expired.</h3>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-around center"><a routerLink="/"><button
            class="btn btn-outline-primary">Back to Home</button></a></div>
    </div>

    <div *ngIf="loader" class="text-center" fxLayoutAlign="space-around center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>

</div>